import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { SelfCheckResult, SelfCheckLeadForm, SelfCheckQuestion } from "@/components/selfcheck/SelfCheckSteps";

export function SelfCheckDialog({ open, onOpenChange }) {
  const nav = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [form, setForm] = useState({ name: "", email: "", care_home_name: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { if (open && !questions.length) api.get("/self-check/questions").then((r) => setQuestions(r.data)).catch(() => {}); }, [open, questions.length]);

  const reset = (o) => { if (!o) { setStep(0); setAnswers({}); setResult(null); } onOpenChange(o); };
  const answer = (v) => { setAnswers({ ...answers, [questions[step].id]: v }); setStep(step + 1); };
  const back = () => setStep(step - 1);
  const atForm = questions.length > 0 && step === questions.length;

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const { data } = await api.post("/self-check", { ...form, answers }); setResult(data); }
    catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const body = () => {
    if (result) return <SelfCheckResult result={result} onExplore={() => { reset(false); nav("/signup"); }} />;
    if (atForm) return <SelfCheckLeadForm form={form} setForm={setForm} loading={loading} onSubmit={submit} onBack={back} />;
    return <SelfCheckQuestion questions={questions} step={step} onAnswer={answer} onBack={back} />;
  };

  return (
    <Dialog open={open} onOpenChange={reset}>
      <DialogContent data-testid="self-check-dialog" className="max-w-xl">{body()}</DialogContent>
    </Dialog>
  );
}
